import DomainResource from './DomainResource';
import merge from 'lodash/merge';
import BN_TreatmentPlanObjectiveIntervention from '@/fhirworks/BN_TreatmentPlanObjectiveIntervention';

export default class BN_TreatmentPlanLibraryObjective extends DomainResource {
    static _className = 'BN_TreatmentPlanLibraryObjective';

    _objectStructure = {
        categoryId: String,
        modal: String,
        display: String,
        intervention: [BN_TreatmentPlanObjectiveIntervention],
        kt: String,
    };

    constructor(constructJson, className = 'BN_TreatmentPlanLibraryObjective') {
        super(constructJson, className);
        // Pre-migration interventions are bare strings — wrap each as { display }
        // so the text survives (a string entry would otherwise construct with display: undefined). Shallow-copy
        // so the caller's object is never mutated.
        let construct = constructJson;
        if (Array.isArray(constructJson?.intervention)) {
            construct = {
                ...constructJson,
                intervention: constructJson.intervention.map((entry) => (typeof entry === 'string' ? { display: entry } : entry)).filter(Boolean),
            };
        }
        this.createAndPopulateStructure(this._objectStructure, construct, this._objectDefaults);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this._objectStructure));
    }
}
